import { ApplyFavoriteAddressPayload, FavoriteAddressState } from 'types/favorite-address';

export type ApplyFavoriteAddressConfirmedPayload = ApplyFavoriteAddressPayload & {
  storeIds?: string[] | null;
};

export type FavoriteSheetData = {
  pickupAddress: FavoriteAddressState['address'];
  minPriceText: string | null;
};

export type FavoriteAddressEvents = {
  'favorite-address/FETCH/init': undefined;
  'favorite-address/FETCH/request': undefined;
  'favorite-address/FETCH/success': FavoriteAddressState;
  'favorite-address/FETCH/failure': undefined;
  'favorite-address/FETCH/loadSheet': { force?: boolean } | undefined;
  'favorite-address/FETCH/sheetSuccess': FavoriteSheetData;
  'favorite-address/RESET': undefined;
  'favorite-address/APPLY/confirm': ApplyFavoriteAddressPayload;
  'favorite-address/APPLY/confirmed': ApplyFavoriteAddressConfirmedPayload;
};

export const FETCH_FAVORITE_ADDRESS = {
  init: 'favorite-address/FETCH/init',
  request: 'favorite-address/FETCH/request',
  success: 'favorite-address/FETCH/success',
  failure: 'favorite-address/FETCH/failure',
  loadSheet: 'favorite-address/FETCH/loadSheet',
  sheetSuccess: 'favorite-address/FETCH/sheetSuccess',
  reset: 'favorite-address/RESET',
} as const;

export const APPLY_FAVORITE_ADDRESS = {
  confirm: 'favorite-address/APPLY/confirm',
  confirmed: 'favorite-address/APPLY/confirmed',
} as const;
